module.exports = __webpack_public_path__ + "static/media/l28_thumb.2975e43a.jpg";